import { memo } from "react";
import * as Styled from "./style";
import router from "next/router";
import { VIDEO_MENUS } from "~/components/blocks/layout/global-navi/const/video-menus";
import { OTHER_LINK } from "~/const/links";
import { useHandleClickByDevice } from "~/hooks/use-handle-click-by-device";
import { useViewableRatingBlock } from "~/hooks/use-viewable-rating-block";
import { sendTrackingClickCommon } from "~/lib/tracking/events";

type Props = {
  closeVideoMenu: () => void;
};

export const VideoMenus = memo(({ closeVideoMenu }: Props) => {
  const { handleClickByDevice } = useHandleClickByDevice();

  const { isAdultLinkAllowed } = useViewableRatingBlock();

  const mainItem = VIDEO_MENUS.map((menu, idx) => {
    if (!isAdultLinkAllowed && menu.name === OTHER_LINK.name) return;
    return (
      <Styled.ButtonMainItem
        key={menu.name}
        {...handleClickByDevice(async () => {
          router.push({
            pathname: menu.pathname,
            query: menu.query,
          });
          sendTrackingClickCommon({
            clickEventName: "dmmtv_navigation",
            viaTargetId: `dmmtv_${menu.query.id}`,
            viaViewRank: idx + 1,
            viaShowPosition: "header",
          });
          closeVideoMenu();
        })}
      >
        {menu.name}
      </Styled.ButtonMainItem>
    );
  });

  return (
    <Styled.DivContainer>
      <Styled.DivWrapper>{mainItem}</Styled.DivWrapper>
    </Styled.DivContainer>
  );
});

VideoMenus.displayName = "VideoMenus";
